export default class FormaPagamento {
  constructor(id = "", formaPagamento = "") {
    this.Id = id
    this.FormaPagamento = formaPagamento
  }
}
